import { TipoParteEmpreendimento } from "../../../../types/empreendimento";

export interface Unidade {
    nome?: string;
    torre: number | ""; // 1, 2, ... para torres; 0 para unidades sem torre
    torre_texto?: string; // Nome customizado da torre (ex.: "Torre A", "Bloco Principal")
    tipo_parte_empreendimento?: (string | number)[];
    area_privativa_m2?: string | number;
    valor_imovel?: string | number;
    valor_avaliacao?: string | number;
    ano_disponibilidade?: number | "";
    mes_disponibilidade?: number | "";
    origem_recurso?: number | "";
    forma_pagamento?: string;
    atributos_extras?: Record<string, any>;
    disponibilidade?: number;
    quantidade_garagem?: number | "";
    mcmv?: boolean;
    tipo_produto?: number | "";
    andar: number | "";
    pavimento_texto?: string;
    numero_apartamento: number | "";
    vagas_rotativas: number | "";
    // Detalhamento de vagas_rotativas: fixa = posição fechada pra unidade;
    // aleatória = pool compartilhado. Aditivos — vagas_rotativas continua
    // existindo do jeito que estava.
    rotativa_fixa?: number | "";
    rotativa_aleatoria?: number | "";
    confirmada?: boolean;
}

export interface Torre {
    nome: string;
    unidades: Unidade[][];
}

// Generalized type for referencing any unit
export type UnitRef = { type: 'torre'; torreIndex: number; andarIndex: number; unidadeIndex: number } | { type: 'avulsa'; unidadeIndex: number };

// Referência a uma linha (andar) inteira de uma torre, usada quando o modelo de
// cópia é a linha toda em vez de uma unidade isolada.
export type RowRef = { torreIndex: number; andarIndex: number };

export const inputStyle = "block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm";
export const primaryButtonStyle = "px-6 py-2 bg-indigo-600 text-white font-semibold rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors disabled:opacity-50";
export const secondaryButtonStyle = "px-6 py-2 bg-white text-gray-700 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors";
export const successButtonStyle = "px-4 py-2 bg-emerald-600 text-white font-semibold rounded-md shadow-sm hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-colors";
export const dangerButtonStyle = "px-2 py-1 bg-red-500 text-white text-xs font-bold rounded-md hover:bg-red-600 transition-colors";

// Cache para definições de tipo de parte para evitar buscas repetidas
export type TiposCache = Record<number, TipoParteEmpreendimento>;